module.exports = __webpack_public_path__ + "img/shop_process.7f7c6cff.png";